import { Action } from 'redux-actions';
import {
	SET_PASSENGER_VALUES,
	SET_PASSENGERS_STATE,
	SetPassengerSeatsAction,
	SetPassengerServicesAction,
	SetPassengerValues
} from './actions';
import { SelectedSeatsServiceType } from '../selectedServices/reducers';
import {
	AviaPassengerType,
	AviaTraveller,
	PassengerSelectedGdsServicesFragment,
	SeatMapRestrictions,
	TravellerFieldEnum,
	ValidationRuleFragment
} from '@websky/graphql';

export type PassengerServices = Partial<PassengerSelectedGdsServicesFragment>;

export interface PassengerValue {
	name?: string;
	value?: string;
	type?: TravellerFieldEnum;
	validationRules?: ValidationRuleFragment[];
}

export interface PassengerState {
	id: string;
	type: AviaPassengerType;
	values: PassengerValue[];
	services?: PassengerServices[];
	seats?: SelectedSeatsServiceType[];
	/** @deprecated Use linkedTravellerIds instead. */
	infantPassengerId?: string;
	linkedTravellerIds?: string[];
	supplierTravellerType?: string;
	seatRestrictions?: SeatMapRestrictions[];
}

export interface PassengersState {
	id: string;
	type: AviaPassengerType;
	values: PassengerValue[];
	supplierTravellerType?: string;
	linkedTraveller?: AviaTraveller;
	seatRestrictions?: SeatMapRestrictions[];
}

export const passengersReducer = (
	state: PassengersState[] = [],
	action: SetPassengerValues | SetPassengerServicesAction | SetPassengerSeatsAction | Action<PassengerState[]>
) => {
	switch (action.type) {
		case SET_PASSENGERS_STATE:
			return action.payload as PassengerState[];

		case SET_PASSENGER_VALUES:
			const valuesData = (action as SetPassengerValues).payload;

			return state.map((passenger, index) => ({
				...passenger,
				values: index === valuesData.id ? valuesData.values : passenger.values
			}));

		/*case SET_PASSENGER_SERVICES:
			const servicesData = (action as SetPassengerServicesAction).payload;

			return state.map((passenger, index) => ({
				...passenger,
				services:
					index === servicesData.id
						? servicesData.services
								.filter(service => service.count > 0)
								.map(service => ({
									serviceId: service.serviceId,
									count: service.count,
									segmentIds: service.segmentIds,
									confirmedCount: service.confirmedCount
								}))
						: passenger.services
			}));

		case SET_PASSENGER_SEATS:
			const seatsData = (action as SetPassengerSeatsAction).payload;

			return state.map((passenger, index) => ({
				...passenger,
				seats: index === seatsData.id ? seatsData.seats : passenger.seats
			}));*/
	}

	return state;
};
